import { useRouter } from 'next/router'
import { useEffect } from 'react'

import { useGetCustomer } from '@unlikelystudio/react-ecommerce-hooks'

export default function useAuthentication(
  redirectOnError: string,
  redirectOnSuccess?: string,
) {
  const router = useRouter()

  useEffect(() => {
    redirectOnError && router.prefetch(redirectOnError as string)
    redirectOnSuccess && router.prefetch(redirectOnSuccess as string)
  }, [])

  const { fetchStatus, isSuccess, ...profileQuery } = useGetCustomer({
    refetchOnMount: true,
    keepPreviousData: true,
    retry: 0,
    onSuccess: (data) => {
      data && redirectOnSuccess && router.replace(redirectOnSuccess)
      !data && redirectOnError && router.replace(redirectOnError)
    },
  })

  const shouldRedirectOnError =
    fetchStatus === 'idle' && redirectOnError && !profileQuery?.data

  useEffect(() => {
    if (shouldRedirectOnError) {
      redirectOnError && router.replace(redirectOnError)
    }
  }, [shouldRedirectOnError])

  return { isIdle: fetchStatus === 'idle', isSuccess, ...profileQuery }
}
